var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InputLabel, OutlinedInput } from '@mui/material';
export default function InputBaseOutlinedInput(props) {
    var value = props.value, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onKeyPress = props.onKeyPress, placeholder = props.placeholder, type = props.type, endAdornment = props.endAdornment, startAdornment = props.startAdornment, _a = props.error, error = _a === void 0 ? false : _a, _b = props.labelSize, labelSize = _b === void 0 ? 'small' : _b, label = props.label, _c = props.inputStyle, inputStyle = _c === void 0 ? {} : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, _e = props.size, size = _e === void 0 ? 'small' : _e, _f = props.block, block = _f === void 0 ? false : _f;
    return (_jsxs(_Fragment, { children: [label && _jsx(InputLabel, __assign({ size: labelSize }, { children: label })), _jsx(OutlinedInput, { inputProps: {
                    style: inputStyle
                }, size: size, onBlur: onBlur, onFocus: onFocus, onChange: onChange, onKeyDownCapture: onKeyPress, endAdornment: endAdornment, startAdornment: startAdornment, value: value, type: type, error: error, placeholder: placeholder, disabled: disabled || block, 
                /* props that can't be overriden via module augmentation but only used for theme purposes */
                // @ts-ignore
                block: block })] }));
}
